import { mount, unmount } from 'svelte';
import App from './App.svelte';

// Import global styles in the correct order
import './styles/theme.css';      // Theme variables first
import './styles/global.css';     // Global reset and base styles
import './styles/utilities.css';  // Utility classes
import './styles/components.css'; // Shared component styles
import './components/AutoTrading/autotrading.css'; // AutoTrader theme tokens + shared dashboard styles (U8/U9)

const target = document.getElementById('app');
if (!target) {
  throw new Error('Root element with id "app" was not found.');
}

// Svelte 5: mount() replaces `new App({ target, props })`.
// Svelte 5 uses event delegation — on:click only fires if the event bubbles
// up to the delegation root (the mount target). Mounting at document.body puts
// that root at the highest bubble point, so a stray overlay over #app cannot
// silently swallow clicks (a regression vs Svelte 4, which listened per-element).
let app = mount(App, {
  target: document.body,
  props: {}
});

export default app;

// Hot Module Replacement (HMR) - for development
if (import.meta.hot) {
  import.meta.hot.accept();
  import.meta.hot.dispose(() => {
    if (app) {
      // Svelte 5: unmount() replaces `app.$destroy()`.
      unmount(app);
    }
  });
}
